// extracted by mini-css-extract-plugin
var _1 = "EpostStatusCell-moduleepostStatusCell__fQAl_ TableCellBase-moduleTableCellBase__GDcv6 TableCell-moduleTableCell__hIV2f";
export { _1 as "epostStatusCell" }
